export function transformSDKFloatToRESTFloat(val) {
    return isFinite(val) ? val : val.toString();
}
export function transformRESTFloatToSDKFloat(val) {
    if (val === 'NaN') {
        return NaN;
    }
    if (val === 'Infinity') {
        return Infinity;
    }
    if (val === '-Infinity') {
        return -Infinity;
    }
    return val;
}
